import React, {useEffect, useState} from "react"
import styles from "../..//assets/css/Loader.module.css"
import loaderLogo from "../../assets/icons/loading/loader_logo.svg"
import {LOADING_TEXT} from "../../utils/constants/Texts";

const Loader: React.FC = () => {
    const [showComponent, setShowComponent] = useState(false)

    useEffect(() => {
        const delay = setTimeout(() => {
            setShowComponent(true)
        }, 50)
        // When pizza modal closes it appears immediately, so added timeout to fix it
        return () => {
            clearTimeout(delay)
        }
    }, [])

    return (
        <div className={showComponent ? styles.loader : styles.loaderstyles + " " + styles.loaderStarting}>
            <div className={styles.loaderImg}>
                <img src={loaderLogo} alt={LOADING_TEXT} width={95} height={95} />
            </div>
        </div>
    )
}
export default Loader
